/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import { Text, TouchableOpacity, View } from 'react-native'
import { withTranslation } from 'react-i18next'
import format from 'string-template'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styles from '../../../styles'
import textStyles from '../../../styles/text'
import buttonStyles from '../../../styles/button'
import { webViewTapped } from '../../../actions/tapEvents'
import env from '../../../env'

function goToResearchStudyURL(clientId) {
  const url = format(env.REACT_APP_RESEARCH_URL, {
    clientId,
  })
  webViewTapped(url, 'bscResearchButton')
}

function BSCResearch({ t, clientId }) {
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={textStyles.bscResearchTitle} testID="bscResearchFaq">{t('feedbackResearchOpportunities')}</Text>
      </View>
      <View>
        <Text style={[textStyles.bscResearchText]} testID="bsc-research-content">{t('feedbackResearchParagraph1')}</Text>
        <TouchableOpacity
          testID="bscResearchFaq-button"
          accessibilityLabel={t('access:faqBSCGetInvolvedResearch')}
          onPress={() => goToResearchStudyURL(clientId)}
          style={styles.blueButton}
        >
          <Text
            maxFontSizeMultiplier={1.5}
            style={[buttonStyles.buttonText, styles.white]}
          >
            {t('feedbackResearchButtonText')}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}

BSCResearch.propTypes = {
  clientId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    clientId: storedData.clientId,
  }
}

export const BSCResearchComponent = BSCResearch

export default withTranslation(['faq', 'common'])(connect(mapStateToProps, null)(BSCResearch))
